export enum AccountSharingEventType {
  ACCOUNT_SHARING_CLOSE_EVENT = 'account_sharing_close_event',
  ACCOUNT_SHARING_SUCCESS_EVENT = 'account_sharing_success_event',
  ACCOUNT_SHARING_TRACKING_EVENT = 'account_sharing_tracking_event',
}



// WEBPACK FOOTER //
// ./ts/app/account-sharing/account-sharing-event-type.ts